import { STATUS_CODE } from 'common/constants';
import { managequesAction } from './manageques.slice';
import { importDataApi, updatequestionnaireNamesApi, downloadImportFileApi } from 'utils/apis';
import { notification } from 'antd';
import { saveAs } from "file-saver";

export const UpdateQuestionnaire = (payload) => async (dispatch) => {
  try {
    dispatch(managequesAction.startLoading());
    const response = await updatequestionnaireNamesApi(payload);
    // Check if the response is successful
    if (response.status === STATUS_CODE.Ok) {
      dispatch(managequesAction.stopLoading(response.data.data));
      notification.success({
        message: 'Success',
        description: 'The questionnaire was updated successfully.',
        duration: 5
      });
    } else {
      dispatch(managequesAction.stopLoading());
      notification.error({
        message: 'Error',
        description: 'Failed to update the questionnaire.',
        duration: 5
      });
    }
  } catch (err) {
    dispatch(managequesAction.stopLoading());
    notification.error({
      message: 'Error',
      description: 'An error occurred while updating the questionnaire.',
      duration: 5
    });

    console.error('Error updating questionnaire:', err);
  }
};
export const importData = (payload) => async (dispatch) => {
  dispatch(managequesAction.startLoading());

  try {
    const response = await importDataApi(payload);

    if (response.status === STATUS_CODE.Ok) {
      dispatch(managequesAction.stopLoading(response.data.data));
      notification.success({
        message: 'Success',
        description: 'The questionnaire was imported successfully.',
        duration: 5
      });
    } else {
      dispatch(managequesAction.stopLoading());
      notification.error({
        message: 'Error',
        description: 'Failed to import the questionnaire.',
        duration: 5
      });
    }
  } catch (err) {
    dispatch(managequesAction.stopLoading());
    notification.error({
      message: 'Error',
      description: 'An error occurred while importing the questionnaire.',
      duration: 5
    });

    console.error('Error importing questionnaire:', err);
  }
};
export const downloadImportFile = (payload) => async (dispatch) => {
  dispatch(managequesAction.startLoading());
  try {
    const response = await downloadImportFileApi(payload);
    if (response.status === STATUS_CODE.Ok) {
      // console.log(response, "1")
      // dispatch(managequesAction.stopLoading(response.data.data));
      // Convert response to Blob
      // Correct way to get blob data
      const arrayBuffer = Uint8Array.from(atob(response?.data?.data), c => c.charCodeAt(0));

      // Create a Blob for the full ZIP (which is actually an Excel file)
      const excelBlob = new Blob([arrayBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

      // Trigger download as an Excel file
      saveAs(excelBlob, "download");
      // message.success("File downloaded successfully!");
      // setLoading(false)
      // form.resetFields();
      // onClose();
      // setLoading(false);

      notification.success({
        message: 'Success',
        description: 'The file was downloaded successfully.',
        duration: 5
      });
    } else {
      // console.log(response, "2")
      dispatch(managequesAction.stopLoading());
      notification.error({
        message: 'Error',
        description: 'Failed to Download the File.',
        duration: 5
      });
    }
  } catch (err) {
    // console.log(err, "3")
    dispatch(managequesAction.stopLoading());
    notification.error({
      message: 'Error',
      description: 'An error occurred while downloading the file.',
      duration: 5
    });

    console.error('Error downloading file:', err);
  }
}
